module.exports = __webpack_public_path__ + "static/media/loading-bars.23fcae85.gif";